/* ---------------------------------------------------------------------------
   LÂPACH — mobile navigation and header scroll state.

   site-v2 built the mobile menu at runtime by scraping the desktop links,
   because the nav was pasted into 24 separate pages and a second copy would
   have drifted. The theme renders both navigations from the same Shopify menu,
   so this only has to open and close the panel.
--------------------------------------------------------------------------- */
(function () {
  "use strict";

  var toggle = document.querySelector("[data-nav-toggle]");
  var panel = document.querySelector("[data-nav-panel]");

  if (toggle && panel) {
    toggle.addEventListener("click", function () {
      var open = panel.classList.toggle("hidden") === false;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.textContent = open ? "close" : "menu";
    });

    /* A resize past the breakpoint should not leave the panel stranded open. */
    window.addEventListener("resize", function () {
      if (window.innerWidth >= 1280 && !panel.classList.contains("hidden")) {
        panel.classList.add("hidden");
        toggle.setAttribute("aria-expanded", "false");
        toggle.textContent = "menu";
      }
    });
  }

  var nav = document.getElementById("nav-container");
  if (nav) {
    var onScroll = function () {
      if (window.pageYOffset > 50) nav.classList.add("bg-white/80", "shadow-sm");
      else nav.classList.remove("bg-white/80", "shadow-sm");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }
})();
